import * as Yup from 'yup';

export const createPageValidationSchema = Yup.object().shape({
  title: Yup.string()
    .required('Title is required')
    .min(3, 'Title must be at least 3 characters')
    .max(100, 'Title must be less than 100 characters'),
  wordsPerPage: Yup.string()
    .required('Words per page is required'),
  totalPages: Yup.string()
    .required('Total pages is required'),
  pageSize: Yup.string()
    .required('Page size is required'),
  storyContent: Yup.string()
    .required('Story content is required')
    .min(50, 'Story content must be at least 50 characters')
    .test('not-empty-whitespace', 'Story content cannot be empty or only whitespace', (value) => {
      return value && value.trim().length > 0;
    }),
  bookStyle: Yup.mixed()
    .test('is-selected', 'Book style is required to generate preview', function(value) {
      if (value === null || value === undefined) {
        return false;
      }
      return true;
    }),
  visualStyle: Yup.mixed()
    .test('is-selected', 'Visual style is required to generate preview', function(value) {
      if (value === null || value === undefined) {
        return false;
      }
      return true;
    }),
  writingStyle: Yup.mixed()
    .test('is-selected', 'Writing style is required to generate preview', function(value) {
      if (value === null || value === undefined) {
        return false;
      }
      return true;
    })
});